<template>
  <section class="uslugi">
    <h1>Usługi</h1>

    <div class="uslugi-blok">
      <p>Wykonujemy usługi w zakresie:</p>
      <ul>
        <li>druku 3D,</li>
        <li>frezowania CNC,</li>
        <li>wymiany sterowania maszyn CNC,</li>
        <li>budowy oraz przebudowy maszyn CNC,</li>
        <li>programowania sterowników PLC.</li>
      </ul>
      <p>
        Po więcej informacji zapraszamy do kontaktu:<br />
        <strong>+48 720 992 745</strong><br />
        <strong><a href="mailto:biuro@birdstool.pl">biuro@birdea.pl</a></strong>
      </p>
    </div>
  </section>
</template>

